import React from 'react'
import { useMemo } from 'react'

import Grid from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'
import Separator from '../../../../components/pdf/Separator'

const Header = () => {
  return (
    <>
      <Grid justify="center" align="center">
        <Image src="/pdfs/vci/v3/header-residence.jpg" ignoreFixedSize />
      </Grid>
      <Separator weight={4} />
    </>
  )
}

export default Header
